module.exports = __webpack_public_path__ + "static/media/beanssproutsalad.4e5582e5.jpg";